import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DhlFormControlLocation } from '../../models/dhl-form-control-location';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { ModalService } from 'src/app/common/modal/modal.service';
import { ErrorsConfig } from 'src/app/common/configuration/errors.config';
import { CommonConfig } from 'src/app/common/configuration/common.config';
import { APP_Constants } from 'src/app/app.constant';
import { Modal } from 'src/app/common/modal/modal';

@Component({
    selector: 'app-form-field-location',
    templateUrl: './form-field-location-v2.component.html',
    styleUrls: ['./form-field-location-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldLocationV2Component implements OnInit {

  constructor(private appService: AppService, private modalService: ModalService) { }

  @Input() configData: DhlFormControlLocation;
  @Input() frmGroup: UntypedFormGroup;
  // @Output() optionSelected: EventEmitter <MatAutocompleteSelectedEvent>

  // items = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  lastkeydown1: number = 0;
  timeout = null;
  locationList = [];
  mapUrl: String = '';
  noItemFound: boolean = false;
  addressId = '';
  locationIdToBeExcluded = '';

  noItemFoundError: string = '';
  selectFromListError: string = '';
  requiredError: string = '';
  searchTerms = new Subject<string>();

  color: String = 'primary';
  mode: String = 'indeterminate';
  mostUsedLocationlist;
  locationIcon;

  fetchMostUsedLocations() {
    let preferredLocation = this.configData.preferredLocation;

    if (preferredLocation && preferredLocation.apiUrl) {
      let url = preferredLocation.apiUrl + localStorage.getItem('userName') + '&customerCode=' +
        localStorage.getItem('customerCode') + '&preferenceType=' + preferredLocation.preferenceType + '&action=' + preferredLocation.action;;
      this.appService.makeHttpGetRequest(url).subscribe((data: any) => {
        console.log(data);
        if (data) {
          if (data[0] !== null) {
            if ((this.frmGroup.get(this.configData.name).value === '' || this.frmGroup.get(this.configData.name).value === null)) {
              this.locationList = data;
              this.locationIcon = 'history';
            }
            if (this.configData.name === 'origin') {
              localStorage.setItem('mostUsedOriginLocations', JSON.stringify(data));
            } else {
              localStorage.setItem('mostUsedDestinationLocations', JSON.stringify(data));
            }
          }
        }
      }, err => {
        console.log(err);
      })
    }
  }

  ngOnInit() {
    console.log(this.frmGroup);
    console.log(this.configData);

    // fix it in simpler way
    this.appService.events$.forEach(event=>{ 
      if(event) {
        if(!(Object.keys(event).length === 0 && event.constructor === Object)){  
          if (event.location === 'reset'){
            if (this.configData.name === 'origin') {
              let list = localStorage.getItem('mostUsedOriginLocations');
              if(list)
                this.locationList = JSON.parse(list);
            } else {
              
              let list = localStorage.getItem('mostUsedDestinationLocations');
              if(list)
                this.locationList = JSON.parse(list);        
            }
          }
        }
      }})

    this.noItemFoundError = ErrorsConfig.autocomplete.notFound;
    this.selectFromListError = ErrorsConfig.autocomplete.selectFromList;
    this.requiredError = ErrorsConfig.required;

    this.locationIcon = 'location_on';
    this.fetchMostUsedLocations();

    if (this.configData['disabled'] === true) {
      this.frmGroup.get(this.configData.name).disable();
    }
    
    this.searchTerms.pipe(debounceTime(CommonConfig.LOCATION_SEARCH_TIMEOUT))
      .subscribe(term => {
        this.makeapicall(term);
        console.log(term);
      })    

    // localStorage.removeItem('locationIdToBeExcluded');
    this.frmGroup.get(this.configData.name)['locationArray'] = [];

    this.configData.validation.forEach(valid => {      
      let check =  valid.split('-');
      if (check[0] === "NotEqualTo") {
        let name = check[1] + 'Id';
        if(check[2] && this.frmGroup.parent['componentType'] == 'WRAPPER'){
          let nextField = this.frmGroup.parent.parent.get(check[2])['controls'][0].get(name);
          this.locationIdToBeExcluded = nextField.value;
        } else{
          this.locationIdToBeExcluded = this.frmGroup.get(name).value;
        }          
      } 
      // else if (check[] === "NotEqualTo-origin") {
      //   this.locationIdToBeExcluded = this.frmGroup.get('originId').value;
      // }
    });

    if (localStorage.getItem('templateName') === 'orderViewEdit' || localStorage.getItem('templateName') === "releaseOrder") {
      this.frmGroup.get(this.configData.name)['locationArray'].push(this.frmGroup.get(this.configData.name).value);
      if (this.configData.name === 'origin') {
        this.mapUrl = localStorage.getItem('originMapUrl');
      } else if (this.configData.name === 'destination') {
        this.mapUrl = localStorage.getItem('destMapUrl');
      }
    }
    // Resetting related columns while reset location component
    // Couldn't use valueChanges event to load data back to selectedLocation.
    // Because valueChanges event will trigger during dropdown selection as well.
    this.frmGroup.get(this.configData.name).valueChanges.subscribe((value)=>{
      if(!value){
        this.frmGroup.get(this.configData.name)['secondaryText'] = '';
        this.noItemFound = false;
        if (this.configData['relatedColumns'] && this.configData['relatedColumns'].length) {
          this.configData['relatedColumns'].forEach(ele => {
            this.frmGroup.get(ele.value).setValue("");
          });
        }
      }
    })
    this.setDefaultData();
  }

  setDefaultData(){
    let locationData = {}
    if (this.configData['relatedColumns'] && this.configData['relatedColumns'].length) {
      this.configData['relatedColumns'].forEach(ele => {
        let value = this.frmGroup.get(ele.value).value;
        if(value){
          locationData[ele.key] = value;
        }
      });
      if(Object.values(locationData).length)
        this.selectedLocation(null, locationData);
    }
  }

  selectedLocation($event, data) {
    this.noItemFound = false;
    let address = '';
    data.addressLine.split(' ').forEach(a => {
      address += '-' + a;
    })
    address = address.substr(1, address.length);

    this.mapUrl = "https://wego.here.com/directions/mix//" + address + ",-" + data.city + ',-' + data.provinceCode + ',-' + data.postalCode + ',-' + data.countryCode + '?map=' + data.latitude + ',' + data.longitude + ',15,normal';
    // this.mapUrl = "https://wego.here.com/directions/mix//" + 550-Polaris-Pkwy,-Westerville,-OH-43082,-USA?map=40.15243,-82.964,15,normal"
    this.frmGroup.get(this.configData.name)['secondaryText'] = data.addressLine + "," + data.city + ',' + data.provinceCode + ',' + data.postalCode;
    this.frmGroup.get(this.configData.name + "Id").setValue(data.locationId);
    if(this.configData['relatedColumns'] && this.configData['relatedColumns'].length){
      this.configData['relatedColumns'].forEach(col => {
        this.frmGroup.get(col.value).setValue(data[col.key]);
      });
    }
    this.locationList = [];
    if (this.configData.name === 'destination' || this.configData.name === 'destLocation') {
      this.appService.setDestinationUsedLocation(data);
    } else {
      this.appService.setOriginUsedLocation(data);
    }
  }

  selection: string;
  getLocationList($event) {
    
    if ($event.currentTarget.value === '') {
      this.locationIcon = 'history';
      this.frmGroup.get(this.configData.name + "Id").setValue('');

      if (this.configData.name === 'origin' || this.configData.name === 'sourceLocation') {
        let list = localStorage.getItem('mostUsedOriginLocations');
        if(list)
          this.locationList = JSON.parse(list);
        else
          this.locationList = [];
      } else {
        
        let list = localStorage.getItem('mostUsedDestinationLocations');
        if(list)
          this.locationList = JSON.parse(list);   
        else
          this.locationList = [];       
      }
    }

    if (this.frmGroup.get(this.configData.name).value !== '') {
      if (this.frmGroup.get(this.configData.name)['locationArray'] && this.frmGroup.get(this.configData.name)['locationArray'].indexOf(this.frmGroup.get(this.configData.name).value) > -1 ||
        (this.locationList.length > 0 && this.selection === this.frmGroup.get(this.configData.name).value)) {
        return;
      } else {
        this.selection = this.frmGroup.get(this.configData.name).value;
      }
    }

    this.configData.validation.forEach(check => {
      let validationCheck = check.split('-');
      if (validationCheck[0] === 'NotEqualTo') {
        if(validationCheck[2] && this.frmGroup.parent['componentType'] == 'WRAPPER'){
          let nextField = this.frmGroup.parent.parent.get(validationCheck[2])['controls'][0].get(validationCheck[1] + 'Id');
          this.locationIdToBeExcluded = nextField.value;
        } else         
          this.locationIdToBeExcluded = this.frmGroup.get(validationCheck[1] + 'Id').value;
      }


      // if(check === "NotEqualTo-destination"){
      //   this.locationIdToBeExcluded = this.frmGroup.get('destinationId').value;
      // } else if(check === "NotEqualTo-origin"){
      //   this.locationIdToBeExcluded = this.frmGroup.get('originId').value;
      // }

    })

    this.frmGroup.get(this.configData.name)['secondaryText'] = '';
    this.noItemFound = false;
    let searchText = $event.currentTarget.value;
    clearTimeout(this.timeout);

    if (searchText.length > 2 && searchText != null) {
      this.locationList = [];
      this.searchTerms.next(searchText);
    } else {
      // this.locationList = []; 
      // this.fetchMostUsedLocations();
      this.frmGroup.get(this.configData.name)['locationArray'] = [];
    }
  }

  // select from list validation for autocomplete
  requireMatch() {
    const selection: any = this.frmGroup.get(this.configData.name).value;
    if (selection !== '') {
      if (this.frmGroup.get(this.configData.name)['locationArray'] && this.frmGroup.get(this.configData.name)['locationArray'].indexOf(selection) < 0) {
        this.frmGroup.get(this.configData.name).setErrors({ 'selectFromList': true });
      }
    }
  }

  progressBar: boolean = false;
  makeapicall(searchText) {
    this.progressBar = true;
    let apiUrl = APP_Constants.LOCATION_SEARCH_URL + localStorage.getItem('customerCode') +
    '&userId=' + localStorage.getItem('userName') +
    "&searchString=" + searchText.toUpperCase() +
    '&locationIdToBeExcluded=' + this.locationIdToBeExcluded;

    if(this.configData['otherApiParam']){
      apiUrl += '&action=' + this.configData['otherApiParam'];
    }

    this.appService.makeHttpGetRequest(apiUrl)
      .subscribe(data => {
        this.progressBar = false;
        if (data['message'].statusCode === APP_Constants.SUCCESS_CODE) {
          this.locationIcon = 'location_on';
          this.locationList = data['locations'];
          this.frmGroup.get(this.configData.name)['locationArray'] = [];
          this.locationList.map((loc) => {
            this.frmGroup.get(this.configData.name)['locationArray'].push(loc.locationId + ' - ' + loc.locationName);
          })
        } else if (data['message'].statusCode === APP_Constants.ERROR_CODE) {
          this.noItemFound = true;
          this.frmGroup.get(this.configData.name)['locationArray'] = [];
          this.locationList = [];
          this.configData.validation.forEach(elem => {
            if (elem === 'Select from list') {
              this.frmGroup.get(this.configData.name).setErrors({ 'NoOrderFound': { 'message': '' } });
            }
          }, this);
        }
      },
        (err) => {
          this.progressBar = false;
          let modal = new Modal({
            action: false, name: 'locationSearch', title: 'Location Search', description: err.message, actionButtonText: ''
          });
          this.modalService.createModalBox(modal, err.status);
        });
  }
}